import { jsx as e } from "react/jsx-runtime";
import "js-cookie";
import { useState as B } from "react";
import { useMediaQuery as F } from "../../hooks/useMediaQuery.js";
import { FlavorIcon as j } from "../../icons/FlavorIcon.js";
import t from "clsx";
import '../../theme.css';import '../../_assets/FlavorBubble.DF7Adxre.css';/* empty css                                          */
var g = "FlavorBubble_flavor__tljix70", h = "FlavorBubble_clickDisabled__tljix71", T = "FlavorBubble_outerTextBubble__tljix72", k = "FlavorBubble_outerTextBubbleHoverable__tljix73", H = "FlavorBubble_isActive__tljix74", I = "FlavorBubble_innerTextBubble__tljix75", C = "FlavorBubble_svgIcon__tljix76";
const d = ({
  interactionDisabled: v = !1,
  renderFlavorName: s = !1,
  flavor: l,
  isActive: r = !1,
  styleOverrides: o,
  onFlavorClick: _
}) => {
  const m = F("s"), c = l.backgroundColor, [x, n] = B(!1), f = l.label.replace(" Flavor", "").replace(" flavor", ""), a = !v && m, u = a && r, p = a && !r && x;
  let b = "default";
  return u ? b = "active" : p && (b = "hover"), /* @__PURE__ */ e(
    "button",
    {
      type: "button",
      className: t(
        g,
        !a && h,
        o == null ? void 0 : o.flavor
      ),
      onClick: (i) => {
        i.preventDefault(), i.stopPropagation(), _(l);
      },
      onMouseEnter: () => n(!0),
      onMouseLeave: () => n(!1),
      disabled: !a,
      "aria-label": `Select ${l.label} flavor`,
      children: s ? /* @__PURE__ */ e(
        "span",
        {
          className: t(
            T,
            a && k,
            u && H
          ),
          children: /* @__PURE__ */ e(
            "span",
            {
              className: t(I, o == null ? void 0 : o.svg),
              style: {
                backgroundColor: c,
                color: l != null && l.useWhiteText ? "#fff" : "#000"
              },
              children: f
            }
          )
        }
      ) : /* @__PURE__ */ e(
        j,
        {
          className: t(C, o == null ? void 0 : o.svg),
          color: c,
          variant: b
        }
      )
    }
  );
};
export {
  d as FlavorBubble
};
